import { Positions } from '../squad-database/api-types';
import { FilterOption, Field, Operation, FilterType } from './types';
import { StringType } from '../../../sv-strings';
export interface GetValueProps {
  isSelected: boolean;
  selectedOptions: string[];
  option: FilterOption;
}
export const getMultipleValues = ({ isSelected, selectedOptions, option }: GetValueProps) =>
  isSelected
    ? selectedOptions.filter((s) => s !== option.value)
    : [...selectedOptions, option.value];

export const getSingleValue = ({ option }: GetValueProps) => [option.value];

export interface FilterConf {
  label: string;
  options: FilterOption[];
  field: Field;
  showImage: boolean;
  getValue: typeof getSingleValue | typeof getMultipleValues;
  operations: Operation[];
  filterType: FilterType;
}

const getSingleFilterConfOptions = (strings: StringType) => [
  {
    // id: 'equalsToEmptyValue',
    label: strings.allPlayers.equalsToAnyValue,
    valueLabel: strings.allPlayers.searchContentLabel,
    value: '',
    operation: Operation.NEQ,
  },
  {
    // id: 'equalsToAnyValue',
    label: strings.allPlayers.equalsToEmptyValue,
    valueLabel: strings.allPlayers.searchContentLabel,
    value: '',
    operation: Operation.EQ,
  },
];
export const getFiltersConf = ({
  strings,
  leagues,
  teams,
}: {
  strings: StringType;
  leagues: FilterOption[];
  teams: FilterOption[];
}): FilterConf[] => [
  {
    label: strings.allPlayers.league,
    options: leagues,
    field: Field.League,
    showImage: true,
    getValue: getMultipleValues,
    operations: [Operation.CS, Operation.NCS],
    filterType: FilterType.MultipleValues,
  },
  {
    label: strings.allPlayers.team,
    options: teams,
    field: Field.Team,
    showImage: true,
    getValue: getMultipleValues,
    operations: [Operation.CS, Operation.NCS],
    filterType: FilterType.MultipleValues,
  },
  {
    label: strings.allPlayers.searchContent,
    options: [],
    field: Field.SearchContent,
    showImage: false,
    getValue: getSingleValue,
    operations: [Operation.CS, Operation.NCS],
    filterType: FilterType.FreeText,
  },
  {
    label: strings.allPlayers.playerPosition,
    options: Object.values(Positions).map((position) => ({
      value: position,
      // id: position,
      label: position,
      operation: Operation.CS,
    })),
    field: Field.PlayerPosition,
    showImage: false,
    getValue: getMultipleValues,
    operations: [Operation.CS, Operation.NCS],
    filterType: FilterType.MultipleValues,
  },
  {
    label: strings.allPlayers.playerImage,
    options: getSingleFilterConfOptions(strings),
    field: Field.PlayerImage,
    showImage: false,
    getValue: getSingleValue,
    operations: [Operation.NEQ, Operation.EQ],
    filterType: FilterType.SingleValue,
  },
  {
    label: strings.allPlayers.playerSmcId,
    options: getSingleFilterConfOptions(strings),
    field: Field.PlayerSmcId,
    showImage: false,
    getValue: getSingleValue,
    operations: [Operation.NEQ, Operation.EQ],
    filterType: FilterType.SingleValue,
  },
  {
    label: strings.allPlayers.playerOptaId,
    options: getSingleFilterConfOptions(strings),
    field: Field.PlayerOptaId,
    showImage: false,
    getValue: getSingleValue,
    operations: [Operation.NEQ, Operation.EQ],
    filterType: FilterType.SingleValue,
  },
  {
    label: strings.allPlayers.playerForzasysId,
    options: getSingleFilterConfOptions(strings),
    field: Field.PlayerForzasysId,
    showImage: false,
    getValue: getSingleValue,
    operations: [Operation.NEQ, Operation.EQ],
    filterType: FilterType.SingleValue,
  },
  {
    label: strings.allPlayers.playerEfId,
    options: getSingleFilterConfOptions(strings),
    field: Field.PlayerEfId,
    showImage: false,
    getValue: getSingleValue,
    operations: [Operation.NEQ, Operation.EQ],
    filterType: FilterType.SingleValue,
  },
  {
    label: strings.allPlayers.playerEsId,
    options: getSingleFilterConfOptions(strings),
    field: Field.PlayerEsId,
    showImage: false,
    getValue: getSingleValue,
    operations: [Operation.NEQ, Operation.EQ],
    filterType: FilterType.SingleValue,
  },
  {
    label: strings.allPlayers.playerShirtNumber,
    options: getSingleFilterConfOptions(strings),
    field: Field.PlayerShirtNumber,
    showImage: false,
    getValue: getSingleValue,
    operations: [Operation.NEQ, Operation.EQ],
    filterType: FilterType.SingleValue,
  },
];
export const getLeagueImage = (league?: string) => {
  if (!league) {
    return null;
  }
  const imageFileName = league.toLowerCase();
  if (
    ['damallsvenskan', 'superettan', 'elitettan', 'futsal', 'allsvenskan'].includes(imageFileName)
  ) {
    return `/leagues/${imageFileName}.png`;
  }

  return null;
};
